import React, { ReactNode, useState, useEffect } from 'react';
import './MessageComponent.styles.scss';
import MessageComponentBase from './MessageComponentBase';
import { ICustomMessageType } from '../../interfaces/component-interfaces';
import { IMessageAttachment } from '../../interfaces/agent-action-interfaces';
import { IUrlData } from '../../interfaces/app-interfaces';
export interface IMessageComponentProps {
  id: string;
  messageType: 'chatbot' | 'user' | 'agent';
  messageContent: string[] | ReactNode;
  isLastMessage?: boolean;
  footer?: { isVisible: boolean; timeStamp?: number; agentName?: string };
  showFeedback?: boolean;
  additionalComponents?: ReactNode;
  isMessageRead?: boolean;
  urlMapping?: IUrlData[];
  customMessageType?: ICustomMessageType;
  attachments?: IMessageAttachment;
  formatType?: string;
}

const MessageComponent: React.FC<IMessageComponentProps> = ({
  messageContent,
  id,
  messageType,
  footer,
  additionalComponents,
  showFeedback,
  isMessageRead = true,
  isLastMessage = false,
  urlMapping,
  customMessageType,
  attachments,
  formatType,
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isTypingComplete, setIsTypingComplete] = useState(false);

  // Handle the typing completion of the current message
  const handleTypingComplete = () => {
    if (Array.isArray(messageContent) && currentIndex < messageContent.length - 1) {
      // Move to the next message after a short pause
      setTimeout(() => {
        setCurrentIndex((prevIndex) => prevIndex + 1);
      }, 500); // 500ms pause between messages
    } else {
      // All messages complete
      setIsTypingComplete(true);
    }
  };

  // Reset state when messageContent changes
  useEffect(() => {
    setCurrentIndex(0);
    setIsTypingComplete(false);
  }, [messageContent]);

  if (Array.isArray(messageContent)) {
    return (
      <>
        {messageContent.slice(0, currentIndex + 1).map((content, index) => (
          <MessageComponentBase
            key={`${id}-${index}`}
            messageContent={content}
            id={`${id}__${index}`}
            messageType={messageType}
            footer={index === messageContent.length - 1 ? footer : undefined}
            additionalComponents={index === messageContent.length - 1 && isTypingComplete ? additionalComponents : undefined}
            showFeedback={showFeedback && index === messageContent.length - 1 && isTypingComplete && !additionalComponents && !customMessageType}
            isMessageRead={isMessageRead}
            isLastMessage={isLastMessage && index === messageContent.length - 1}
            disableTypingEffect={index < currentIndex}
            onTypingComplete={index === currentIndex ? handleTypingComplete : undefined}
            urlMapping={urlMapping}
            attachments={attachments}
            formatType={formatType}
          />
        ))}
      </>
    );
  }

  return (
    <MessageComponentBase
      key={id}
      messageContent={messageContent}
      id={id}
      messageType={messageType}
      footer={footer}
      additionalComponents={additionalComponents}
      showFeedback={showFeedback && isTypingComplete && !additionalComponents && !customMessageType}
      isMessageRead={isMessageRead}
      isLastMessage={isLastMessage}
      urlMapping={urlMapping}
      attachments={attachments}
      formatType={formatType}
    />
  );
};

export default MessageComponent;
